namespace RedBullMOBILE360.AutomaticReports {
    export interface ReportRow {
        Id?: number;
        ReportChannel?: Web.Modules.Common.ReportChannel;
        Subject?: string;
        Template?: string;
        Schedule?: string;
        IsEnabled?: number;
        Recipients?: string;
    }

    export namespace ReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Subject';
        export const localTextPrefix = 'AutomaticReports.Report';
        export const lookupKey = 'AutomaticReports.Report';

        export function getLookup(): Q.Lookup<ReportRow> {
            return Q.getLookup<ReportRow>('AutomaticReports.Report');
        }
        export const deletePermission = 'Reports:Setup';
        export const insertPermission = 'Reports:Setup';
        export const readPermission = 'Reports:Setup';
        export const updatePermission = 'Reports:Setup';

        export declare const enum Fields {
            Id = "Id",
            ReportChannel = "ReportChannel",
            Subject = "Subject",
            Template = "Template",
            Schedule = "Schedule",
            IsEnabled = "IsEnabled",
            Recipients = "Recipients"
        }
    }
}
